import { useLang } from "@/i18n/LanguageContext";

const Marquee = () => {
  const { t } = useLang();
  const items = Array.from({ length: 5 });
  return (
    <div
      data-testid="marquee"
      className="relative overflow-hidden bg-[var(--yellow)] py-4 text-[var(--charcoal)]"
      aria-hidden="true"
    >
      <div className="ap-marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {items.concat(items).map((_, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="ap-display text-base font-bold sm:text-lg">{t.marquee}</span>
            <span className="h-2 w-2 rounded-full bg-[var(--charcoal)]" />
            <span className="ap-mono text-[12px] font-bold uppercase tracking-[0.35em]">APEX DOORS</span>
            <span className="h-2 w-2 rounded-full bg-[var(--charcoal)]" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
